import { render, staticRenderFns } from "./Phases.vue?vue&type=template&id=345ea2ef"
import script from "./Phases.vue?vue&type=script&lang=js"
export * from "./Phases.vue?vue&type=script&lang=js"
import style0 from "./Phases.vue?vue&type=style&index=0&id=345ea2ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports